<template>
  <div>
    <ErrorMessage :error="error" />
    <input
      :id="id"
      :value="modelValue"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      :autocomplete="autocomplete"
      class="input"
      :class="{ 'has-error': error }"
      @keydown="onKeyDown"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, watch } from 'vue'

import ErrorMessage from './ErrorMessage'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  label: {
    type: String,
    default: undefined,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  name: {
    type: String,
    default: undefined,
  },
  autocomplete: {
    type: String,
    default: undefined,
  },
  required: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: undefined,
  },
})

const emit = defineEmits(['update:modelValue', 'update:error'])

const { uid } = getCurrentInstance()
const id = computed(() => `input-${uid}`)

watch(
  () => props.modelValue,
  () => {
    emit('update:error', undefined)
  },
)

function onKeyDown(e) {
  if (props.type == 'email' && e.which == 32) {
    e.preventDefault()
  }
}
</script>

<style lang="postcss" scoped>
.input:-webkit-autofill,
.input:-webkit-autofill:hover {
  -webkit-text-fill-color: rgb(0, 0, 0);
}
.input:-webkit-autofill:focus {
  caret-color: rgb(0, 0, 0);
  -webkit-text-fill-color: rgb(0, 0, 0);
}

.input {
  @apply w-full py-4 px-3;
  @apply leading-8 text-base outline-none rounded-md;
  @apply bg-white;
  @apply transition-all duration-300;
  @apply text-black;
}
.input:focus {
  @apply ring-2 ring-blue-500 border-transparent;
}
.input.has-error {
  @apply border-red-600;
}
.input.has-error:-webkit-autofill:focus {
  @apply border-red-600;
}

.input::-webkit-calendar-picker-indicator {
  @apply w-0 h-0;
}
</style>
